import { Component, computed, inject, input, LOCALE_ID, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OrderFilters as OrderFiltersModel } from '../../../../../pages/admin-dashboard/orders-management/orders.model';
import { FilterInput } from '../../../../../shared/ui/shared-filters/filter-input/filter-input';
import { FilterSelectComponent } from '../../../../../shared/ui/shared-filters/filter-select-component/filter-select-component';
import { FilterDateComponent } from '../../../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { OrderService } from '../../../../../services/orders/order.service';
import { OrderLookup } from '../../../../../pages/admin-dashboard/orders-management/orders.model';
import { DestroyRef } from '@angular/core';

@Component({
  selector: 'app-filters',
  imports: [FilterInput, FilterDateComponent, FilterSelectComponent],
  templateUrl: './filters.html',
  styleUrl: './filters.scss',
})
export class Filters {
  private locale = inject(LOCALE_ID);
  private destroyRef = inject(DestroyRef);
  private orderService = inject(OrderService);

  filters = input.required<OrderFiltersModel>();
  applyFilters = output<OrderFiltersModel>();
  resetFilters = output();

  // Order ID
  orderId = signal<number | null>(null);

  // Status
  statuses = signal<OrderLookup[]>([]);
  selectedStatusId = signal<number | null>(null);

  statusOptions = computed(() => this.statuses().map((s) => ({ id: s.id, titleEn: s.titleEn, titleAr: s.titleAr })));

  // Dates
  createdOnFrom = signal<string | null>(null);
  createdOnTo = signal<string | null>(null);
  lastModifiedOnFrom = signal<string | null>(null);
  lastModifiedOnTo = signal<string | null>(null);

  // Validation
  createdDateInvalid = signal(false);
  lastModifiedDateInvalid = signal(false);

  isArabic = computed(() => this.locale.startsWith('ar'));

  ngOnInit(): void {
    this.loadStatuses();
  }

  loadStatuses() {
    const subscription = this.orderService.getOrderStatuses().subscribe({
      next: (res) => this.statuses.set(res.list),
      error: () => {},
    });
    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  onContainerClick(event: Event) {
    event.stopPropagation();
  }

  onResetFilters() {
    this.orderId.set(null);
    this.selectedStatusId.set(null);
    this.createdOnFrom.set(null);
    this.createdOnTo.set(null);
    this.lastModifiedOnFrom.set(null);
    this.lastModifiedOnTo.set(null);
    this.createdDateInvalid.set(false);
    this.lastModifiedDateInvalid.set(false);
    this.resetFilters.emit();
  }

  onApplyFilters() {
    const createdInvalid = !!(
      this.createdOnFrom() &&
      this.createdOnTo() &&
      this.createdOnFrom()! > this.createdOnTo()!
    );
    const lastModInvalid = !!(
      this.lastModifiedOnFrom() &&
      this.lastModifiedOnTo() &&
      this.lastModifiedOnFrom()! > this.lastModifiedOnTo()!
    );

    this.createdDateInvalid.set(createdInvalid);
    this.lastModifiedDateInvalid.set(lastModInvalid);
    if (createdInvalid || lastModInvalid) return;

    this.applyFilters.emit({
      orderId: this.orderId() ?? undefined,
      requestStatusId: this.selectedStatusId() ?? undefined,
      createdOnFrom: this.createdOnFrom() ?? undefined,
      createdOnTo: this.createdOnTo() ?? undefined,
      lastModifiedOnFrom: this.lastModifiedOnFrom() ?? undefined,
      lastModifiedOnTo: this.lastModifiedOnTo() ?? undefined,
    });
  }
}
